import React from "react";

interface Props {
  className?: string
}

const PanelSegmentButtonBar = (props: React.PropsWithChildren<Props>) => {
  return <div className={"flex " + props.className}>
    <div className="grow1"></div>
    <div>
      {props.children}
    </div>
  </div>;
};

export default PanelSegmentButtonBar;